/**
 * `SavedSearchWidget` renders all the saved searches in a vertical list that shows
 * up during the initial rendering of the search sidebar. Once the user is "in" a search,
 * `SavedSearchWidget` only renders searches saved by the user during the active
 * search
 */

import React from 'react';
import SavedSearchFlatButton from 'components/pure/search/SavedSearchFlatButton';
require('styles/SavedSearchWidget.styl');

class SavedSearchWidget extends React.Component {
  render() {
    if (this.props.searches.isEmpty()) {
      return null;
    } else {
      return (
        <div className="saved-search-widget-container">
          <div className="widget title">
            <span>Saved Searches:</span>
          </div>
          <div className="widget link-widget">
            {this.props.searches
              .map(search => {
                return (
                  <SavedSearchFlatButton
                    key={search.id}
                    savedSearch={search}
                    SavedSearchActions={this.props.SavedSearchActions}
                    isInSearchMode={this.props.isInSearchMode}
                  />
                );
              })
              .toArray()}
          </div>
        </div>
      );
    }
  }
}

export default SavedSearchWidget;
